import { capitalize } from 'lodash'
import { UpdateEntityDetailsClientRequest } from '../../../@types/UpdateEntityDetails'
import { FormContactValuesProps } from '../../../Components/OwnerData/components/ContactForm'
import { usePolicyholderDetailsStore } from '../../../Stores/policyholderDetailsStore'
import { ID_EXTERNAL_TYPES } from '../../../constants/idExternalTypes'
import { useGetAdditionalEntityDetailsStore } from './../../../Stores/useGetAdditionalEntityDetailsStore'

export const useContactUpdateEntityPayload = () => {
  const { policyholderDetailsSelected } = usePolicyholderDetailsStore()
  const { policyholderAdditionalDetails } = useGetAdditionalEntityDetailsStore()

  const commonPayload = {
    idEntity: policyholderDetailsSelected?.idEntity || '',
    entityType: capitalize(policyholderDetailsSelected?.entityType || '') || '',
    vatNumber: policyholderDetailsSelected?.vatNumber || '',
    idExternalType: ID_EXTERNAL_TYPES.globalEntity || '',
    name: policyholderDetailsSelected?.name || '',
    countryCode: policyholderDetailsSelected?.addresses?.[0]?.countryCode || '',
    countryDescription:
      policyholderDetailsSelected?.addresses?.[0]?.countryDescription || '',
  }

  const handleContactPayload = (formValues: FormContactValuesProps) => {
    const payload: UpdateEntityDetailsClientRequest = {
      ...commonPayload,
      contactRequest: {
        phoneContactTypology: formValues?.contactPhone || '',
        phoneContactTypologyDescription: formValues?.contactDescription || '',
        phoneNumber: Number(formValues?.contactPhoneNumber),
      },
    }

    return payload
  }

  const handleEditEmailPayload = (email: string) => {
    const payload: UpdateEntityDetailsClientRequest = {
      ...commonPayload,
      contactRequest: {
        email: email || '',
        emailId:
          policyholderAdditionalDetails?.emailContact?.emailContactID || '1',
      },
    }

    return payload
  }

  return {
    handleContactPayload,
    handleEditEmailPayload,
  }
}
